/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import ErrorBoundary from 'base/components/ErrorBoundary';
import LabradorColumns from 'base/components/labrador/Columns';

export const DynamicLabradorColumns: typeof LabradorColumns = (props) => {
    return <ErrorBoundary><LabradorColumns {...props} /></ErrorBoundary>;
}
export type DynamicLabradorColumnsProps = PropsFromComponent<typeof LabradorColumns>;
